const common = {
  // Navigation
  "nav.home": "首頁",
  "nav.capabilities": "核心能力",
  "nav.architecture": "技術架構",
  "nav.consensus": "共識與安全",
  "nav.developers": "開發者",
  "nav.rwa": "RWA應用",
  "nav.rmind": "R-Mind",
  "nav.docs": "文檔",
  "nav.launch": "啟動應用",

  // Hero Section
  "hero.badge": "新一代 RWA 基礎設施",
  "hero.title": "為現實世界資產而生的區塊鏈基礎設施",
  "hero.subtitle": "RoonChain 是專為現實世界資產（RWA）打造的高性能 Layer 1 區塊鏈，實現無縫鏈上結算與跨域協作",
  "hero.cta.start": "探索更多",
  "hero.cta.docs": "白皮書",
  "hero.card.block": "區塊已確認",
  "hero.card.gas": "燃料費",

  // Core Capabilities
  "core.title": "核心能力",
  "core.subtitle": "針對複雜 RWA 場景優化的企業級基礎設施，支持真實世界的鏈上協同",
  "core.performance.title": "高性能執行",
  "core.performance.desc": "針對高頻資產結算優化，在真實負載下保持持續吞吐與快速確認",
  "core.performance.feature1": "並行交易處理引擎",
  "core.performance.feature2": "優化的狀態存儲",
  "core.performance.feature3": "即時最終性確認",
  "core.modular.title": "分層模組化架構",
  "core.modular.consensus": "共識層",
  "core.modular.consensus.desc": "網絡安全與狀態一致性",
  "core.modular.execution": "執行層",
  "core.modular.execution.desc": "高並發交易處理",
  "core.modular.data": "數據層",
  "core.modular.data.desc": "可驗證存儲與審計支持",
  "core.crosschain.title": "跨鏈互操作",
  "core.crosschain.desc": "多鏈資產與數據協同，連接不同生態，提升 RWA 流動性",
  "core.rwa.title": "RWA 原生設計",
  "core.rwa.desc": "為多方協作、狀態轉換與結構化權益表達而生，專為複雜資產場景打造",
  "core.rwa.tag1": "多方協作",
  "core.rwa.tag2": "結構化",
  "core.rwa.tag3": "合規",
  "core.security.title": "去中心化安全",
  "core.security.desc": "驗證者優先的安全模型，確保鏈上狀態可驗證與長期穩定運行",

  // RWA Applications
  "rwa.title": "RWA 應用場景",
  "rwa.subtitle": "為多樣化現實資產形態與複雜協作機制提供通用技術基礎",
  "rwa.realestate": "不動產",
  "rwa.realestate.desc": "房產收益權、長期租賃與結構化權益代幣化",
  "rwa.energy": "能源與資源",
  "rwa.energy.desc": "能源收益結構、礦產權益與長週期項目融資",
  "rwa.commodity": "大宗商品",
  "rwa.commodity.desc": "商品結算與供應鏈收益權代幣化",
  "rwa.structured": "結構化收益",
  "rwa.structured.desc": "多來源收益組合與可持續資產模型",
  "rwa.onchain.title": "鏈上結算",
  "rwa.onchain.desc": "從發行到結算的完整資產生命週期管理，全程鏈上記錄確保透明",
  "rwa.onchain.note": "支持多種資產類型，採用標準化代幣化協議",
  "rwa.onchain.tag1": "代幣化",
  "rwa.onchain.tag2": "結算",
  "rwa.onchain.tag3": "生命週期",
  "rwa.compliance.title": "合規框架",
  "rwa.compliance.desc": "內置監管合規工具，支持跨司法管轄區的 KYC/AML 要求",
  "rwa.compliance.note": "靈活的合規模組，可適應不同監管環境",
  "rwa.compliance.tag1": "身份驗證",
  "rwa.compliance.tag2": "跨司法管轄",
  "rwa.compliance.tag3": "模組化",

  // Technical Architecture
  "tech.badge": "技術架構",
  "tech.title": "分層模組化架構",
  "tech.desc1": "RoonChain 採用分層模組化設計，將共識、執行、數據層解耦，支持獨立擴展與升級。",
  "tech.desc2": "這種架構在確保系統穩定性的同時，為未來技術演進提供靈活性。",
  "tech.uptime": "網絡正常運行時間",
  "tech.uptime.desc": "企業級可靠性，配備冗餘基礎設施",
  "tech.finality": "區塊確認時間",
  "tech.finality.desc": "快速確認滿足實時結算需求",
  "tech.cta": "查看技術文檔",
  "tech.tps": "TPS 吞吐量",
  "tech.nodes": "驗證節點",
  "tech.uptime.label": "正常運行",
  "tech.evm": "EVM 兼容",
  "tech.layered.title": "分層架構",
  "tech.layered.layers": "層",
  "tech.layered.tag1": "模組化",
  "tech.layered.tag2": "可擴展",
  "tech.layered.tag3": "可升級",
  "tech.parallel.title": "並行處理",
  "tech.parallel.desc": "高效並行交易執行",
  "tech.optimized.title": "狀態存儲",
  "tech.optimized.desc": "優化狀態樹結構",
  "tech.zerotrust.title": "安全驗證",
  "tech.zerotrust.desc": "零信任安全模型",
  "tech.explore.title": "探索完整技術文檔",
  "tech.explore.desc": "了解 RoonChain 的技術細節與實現原理",

  // Developer Support
  "dev.title": "開發者支持",
  "dev.subtitle": "構建生產級 RWA 應用的完整工具包，配備全面的技術文檔",
  "dev.evm.title": "EVM 兼容",
  "dev.evm.desc": "全面支持 Solidity 與以太坊生態工具",
  "dev.tools.title": "開發工具",
  "dev.tools.desc": "端到端的開發、測試與部署工作流",
  "dev.tools.rpc": "RPC 節點",
  "dev.tools.explorer": "瀏覽器",
  "dev.tools.api": "API",
  "dev.tools.sdk": "SDK",
  "dev.docs.title": "技術文檔",
  "dev.docs.desc": "全面且持續更新的技術文檔",
  "dev.docs.quickstart": "快速開始",
  "dev.docs.quickstart.desc": "幾分鐘內上手",
  "dev.docs.api": "API 參考",
  "dev.docs.api.desc": "完整的 API 文檔",
  "dev.docs.examples": "代碼示例",
  "dev.docs.examples.desc": "即用型模板",
  "dev.docs.best": "最佳實踐",
  "dev.docs.best.desc": "生產環境指南",
  "dev.cta.title": "準備好開始構建了嗎？",
  "dev.cta.desc": "加入我們的開發者社群，立即開始在 RoonChain 上構建",
  "dev.cta.docs": "閱讀文檔",
  "dev.cta.github": "GitHub",
  "dev.stats.developers": "活躍開發者",
  "dev.stats.contracts": "已部署合約",
  "dev.stats.projects": "開源項目",
  "dev.stats.support": "技術支持",

  // Consensus Section
  "consensus.badge": "共識機制",
  "consensus.title": "共識與安全",
  "consensus.subtitle": "安全優先的設計，平衡性能、去中心化與運營效率",
  "consensus.mechanism.title": "共識機制",
  "consensus.mechanism.desc1": "拜占庭容錯共識確保網絡安全",
  "consensus.mechanism.desc2": "分佈式驗證避免單點故障",
  "consensus.mechanism.desc3": "支持治理升級與協議演進",
  "consensus.mechanism.metric": "網絡共識率",
  "consensus.performance.title": "性能與擴展",
  "consensus.performance.desc1": "針對高頻結算場景優化",
  "consensus.performance.desc2": "峰值負載下穩定的交易處理",
  "consensus.performance.desc3": "隨驗證者網絡增長水平擴展",
  "consensus.performance.tps": "TPS",
  "consensus.performance.confirm": "確認",
  "consensus.performance.availability": "可用性",
  "consensus.security.title": "安全模型",
  "consensus.security.desc1": "抵禦惡意節點攻擊",
  "consensus.security.desc2": "網絡異常檢測與恢復",
  "consensus.security.desc3": "鏈下不確定性處理機制",
  "consensus.security.feature1": "多重簽名驗證",
  "consensus.security.feature2": "懲罰條件",
  "consensus.security.feature3": "緊急治理",
  "consensus.evm.title": "EVM 兼容性",
  "consensus.evm.desc1": "與以太坊生態無縫集成",
  "consensus.evm.desc2": "支持現有智能合約和工具",
  "consensus.evm.desc3": "為 Web3 開發者提供熟悉的開發體驗",
  "consensus.crosschain.title": "跨鏈橋",
  "consensus.crosschain.desc": "通過密碼學驗證和去中心化驗證，實現多個區塊鏈網絡間的安全資產轉移。",
  "consensus.crosschain.note": "支持主要 L1 鏈和 L2 Rollup，統一流動性池",
  "consensus.crosschain.chains": "支持鏈",
  "consensus.crosschain.verify": "驗證率",

  // R-Mind Section
  "rmind.title": "R-Mind",
  "rmind.subtitle": "AI 驅動的智能層",
  "rmind.desc1": "R-Mind 是 RoonChain 的 AI 智能層，提供智能分析和自動化能力。",
  "rmind.desc2": "通過機器學習和數據分析增強網絡運行與資產管理能力。",
  "rmind.ai.title": "AI 智能層",
  "rmind.ai.feature1": "資產狀態實時評估",
  "rmind.ai.feature2": "風險識別與預警",
  "rmind.ai.feature3": "智能決策支持",
  "rmind.ai.tag1": "機器學習",
  "rmind.ai.tag2": "自然語言",
  "rmind.ai.tag3": "預測分析",
  "rmind.analysis.title": "智能分析",
  "rmind.analysis.desc": "資產狀態評估、風險識別與複雜場景決策支持",
  "rmind.automation.title": "自動化工作流",
  "rmind.automation.desc": "基於規則的觸發、流程執行與任務編排，提升運營效率",
  "rmind.rwa.title": "RWA 優化",
  "rmind.rwa.desc": "複雜資產邏輯處理、長期管理與多方規則協調",
  "rmind.principles.title": "核心原則",
  "rmind.principles.rule": "AI 輔助但不繞過規則",
  "rmind.principles.verify": "關鍵執行需鏈上驗證",
  "rmind.principles.audit": "所有行為可審計、可追溯",
  "rmind.cta": "探索 R-Mind",
  "rmind.security.title": "安全設計",
  "rmind.security.item1": "沙箱化 AI 執行環境",
  "rmind.security.item2": "關鍵決策人工介入",
  "rmind.security.item3": "透明的決策審計追蹤",
  "rmind.future.title": "未來路線圖",
  "rmind.future.desc": "持續增強 AI 能力，包括高級預測分析、自然語言接口，以及用於複雜 RWA 管理場景的自主代理框架。",
  "rmind.stats.models": "AI 模型",
  "rmind.stats.data": "數據處理/日",
  "rmind.stats.latency": "響應延遲",
  "rmind.stats.accuracy": "準確率",

  // Footer
  "footer.newsletter": "輸入您的郵箱",
  "footer.tagline1": "構建未來",
  "footer.tagline2": "現實世界資產",
  "footer.network.title": "網絡信息",
  "footer.network.name": "網絡名稱",
  "footer.network.symbol": "代幣符號",
  "footer.network.chainId": "鏈 ID",
  "footer.network.explorer": "區塊瀏覽器",
  "footer.contracts.title": "合約地址",
  "footer.contracts.nodeNft": "節點 NFT",
  "footer.links.title": "快捷鏈接",
  "footer.links.explorer": "區塊瀏覽器",
  "footer.email.title": "聯繫我們",
  "footer.email.rwa": "RWA 與企業資產合作",
  "footer.email.tech": "技術支持與開發者服務",
  "footer.email.biz": "商務合作與生態夥伴",
  "footer.email.legal": "法務與合規事務",
  "footer.email.contact": "通用諮詢",
  "footer.protocol": "協議",
  "footer.protocol.consensus": "共識機制",
  "footer.protocol.architecture": "技術架構",
  "footer.protocol.security": "安全性",
  "footer.developers": "開發者",
  "footer.developers.docs": "文檔",
  "footer.developers.github": "GitHub",
  "footer.developers.tools": "工具",
  "footer.resources": "資源",
  "footer.resources.blog": "博客",
  "footer.resources.research": "研究",
  "footer.resources.media": "媒體資料",
  "footer.community": "社群",
  "footer.community.discord": "Discord",
  "footer.community.twitter": "Twitter",
  "footer.community.forum": "論壇",
  "footer.copyright": "© 2024 RoonChain. 保留所有權利。",
  "footer.privacy": "隱私政策",
  "footer.description": "RoonChain 是專為現實世界資產代幣化打造的高性能 Layer 1 區塊鏈。",
  "footer.copyright.full": "© RoonChain. All rights reserved.",
  "footer.copyright.content": "本網站及其所包含的全部內容，包括但不限於文字、圖表、架構說明、技術描述、系統設計、頁面佈局與視覺元素，均受適用的著作權法律及相關法律法規保護。",
  "footer.copyright.permission": "未經事先書面許可，任何個人或機構不得以任何形式複製、轉載、修改、傳播或用於商業用途。",
  "footer.copyright.disclaimer": "本網站內容僅用於技術與資訊展示，不構成任何形式的投資建議、要約或承諾。",
};

export default common;
